import { gql } from '@apollo/client';
import metadataOperationResultFragment from '@shared/queries/metadataOperationResultFragment';

const MOVE_USER_LICENSE_TO_ORG = gql`
  mutation MoveUserLicenseToOrg($userLicenseInfo: MoveUserLicenseToOrgInput!) {
    moveUserLicenseToOrg(userLicenseInfo: $userLicenseInfo) {
      ...MetadataOperationResultFields
    }
  }
  ${metadataOperationResultFragment}
`;

export default MOVE_USER_LICENSE_TO_ORG;
